import { Component, HostListener, OnInit, Output, signal } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/libs/api/api.service';
import { ApiRegisterUser } from 'src/libs/models/Register.model';
import { LoginHeaderService } from 'src/libs/state/login-header.service';
import { StateService } from 'src/libs/state/state.service';

@Component({
  selector: 'fini-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss'],
  standalone: false,
})
export class LoginRegisterComponent implements OnInit {
  constructor(
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: HotToastService,
    private fb: UntypedFormBuilder,
    private stateService: StateService,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Register',
      subtitle: 'Register your free account to get started',
    });
  }

  loading$ = new BehaviorSubject(false);
  @Output() loading = this.loading$.asObservable();

  registerForm = this.fb.group({
    email: '',
    username: '',
    password: '',
    password_again: '',
    turnstile: '',
    redirect: '',
  });

  passwordStrength = 0;
  turnstile_load_ad = signal(false);

  ngOnInit(): void {
    this.registerForm.patchValue({
      redirect: this.route.snapshot.queryParams['redirect'],
    });

    this.turnstileLoaded();
  }

  turnstileLoaded() {
    console.log('turnstile loaded');
    setTimeout(() => {
      this.turnstile_load_ad.set(true);
    }, 1000);
  }

  registerUser() {
    const request = this.registerForm.value;

    if (!this.registerForm.valid) {
      this.toast.error(`Fill out all required fields!`);
      return;
    }

    if (this.passwordStrength < 3) {
      this.toast.error('Your password is too weak, choose a stronger one.');
      return;
    }

    // Check password matched password_again
    if (request.password !== request.password_again) {
      this.toast.error('Passwords must match');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(request.email)) {
      this.toast.error('Please enter a valid email address');
      return;
    }

    this.loading$.next(true);

    this.api.post<ApiRegisterUser>(`register`, request).subscribe((res) => {
      this.loading$.next(false);
      if (!res.success) {
        this.toast.error('Registration failed: ' + res.message);
      } else {
        this.stateService.set({
          postRegistrationDetails: {
            username: request.username,
            password: request.password,
          },
        });

        this.router.navigate(['register/checkemail']);
      }
    });
  }

  onTurnstileResolved(captchaResponse: string) {
    this.registerForm.patchValue({ turnstile: captchaResponse });
  }
}
